import type { Study } from '@bioavail/shared-types';
import {
  CalculationMode as CM,
  RouteOfAdministration as ROA,
  ArmRole as AR,
} from '@bioavail/shared-types';

// Re-export test/shared utilities from shared-logic
export { createStudy, createArm } from '@bioavail/shared-logic/testing/factory';

/**
 * Build a default Study for first-load initialization (P1.3.1).
 * Two arms (test first) with default units.
 */
export function createDefaultStudy(): Study {
  // Inline minimal factory to avoid circular dependency on testing module
  const now = new Date().toISOString();
  return {
    id: `study-${Date.now().toString(36)}`,
    name: 'Untitled Study',
    mode: CM.Absolute,
    studyType: 'single_dose',
    arms: [
      {
        id: 'arm-test',
        label: 'Test (Oral)',
        route: ROA.Oral,
        role: AR.Test,
        dose: 200,
        doseUnit: 'mg',
        analyteType: 'parent',
        concentrationUnit: 'ng/mL',
        timeUnit: 'h',
        dataPoints: [],
        usesDirectAuc: false,
        trapezoidalRule: 'linear_up_log_down',
        blqRule: 'M1',
        lambdaZManualOverride: false,
      },
      {
        id: 'arm-ref',
        label: 'Reference (IV)',
        route: ROA.IV,
        role: AR.Reference,
        dose: 100,
        doseUnit: 'mg',
        analyteType: 'parent',
        concentrationUnit: 'ng/mL',
        timeUnit: 'h',
        dataPoints: [],
        usesDirectAuc: false,
        trapezoidalRule: 'linear_up_log_down',
        blqRule: 'M1',
        lambdaZManualOverride: false,
      },
    ],
    aucInterval: '0-inf',
    createdAt: now,
    updatedAt: now,
  };
}

/** Generate a pseudo-unique id (offline, no crypto dependency). */
export function uid(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
